/**
 * statsMark - 埋点字段
 * projectArea - 事件页面区域
 * eventArea - 事件区域
 * eventType - 事件类型 1跳转 2 .浏览 非跳转ajax 3.点击事件 4.滚动下拉上拉事件 5.填写表单事件
 * eventName - 事件别名
 */

export const globalData = {
  eventId: []
};

export const statsData = [
  {
    statsMark: "企业落地页-登录企业版按钮点击pv",
    projectArea: "63",
    eventArea: "63",
    eventType: "3",
    eventId: "253",
    eventName: "company_vip_page_login_pv"
  },
  {
    statsMark: "企业落地页-开通企业版按钮点击pv",
    projectArea: "63",
    eventArea: "63",
    eventType: "3",
    eventId: "255",
    eventName: "company_vip_page_buy_pv"
  },
  {
    statsMark: "企业落地页-联系客服按钮点击pv",
    projectArea: "63",
    eventArea: "63",
    eventType: "3",
    eventId: "258",
    eventName: "company_vip_page_customer_pv"
  },
  {
    statsMark: "企业落地页-表单提交按钮点击pv",
    projectArea: "63",
    eventArea: "63",
    eventType: "3",
    eventId: "259",
    eventName: "company_vip_page_submit_pv"
  },
  {
    statsMark: "企业落地页-基础协作版-立即开通按钮点击pv",
    projectArea: "63",
    eventArea: "63",
    eventType: "3",
    eventId: "260",
    eventName: "company_vip_page_buy_basics_pv"
  },
  {
    statsMark: "企业落地页-高级协作版-立即开通按钮点击pv",
    projectArea: "63",
    eventArea: "63",
    eventType: "3",
    eventId: "261",
    eventName: "company_vip_page_buy_senior_pv"
  },
  {
    statsMark: "企业落地页-企业旗舰版-咨询顾问按钮点击pv",
    projectArea: "63",
    eventArea: "63",
    eventType: "3",
    eventId: "262",
    eventName: "company_vip_page_buy_consulting_pv"
  },
  {
    statsMark: "企业落地页浏览",
    projectArea: "63",
    eventArea: "63",
    eventType: "2",
    eventId: "264",
    eventName: "company_vip_page_pv"
  },
];
